<template>
	<div>
		<h5>VideoLinkage</h5>
	</div>
</template>

<script>
	export default {
		name: "VideoLinkage",
	};
</script>

<style scoped></style>
